

















import { Vue, Component } from "vue-property-decorator";
import { isOfficeAdminPortalClient } from "@/permissions/ClientPermissions";
import { getCockpitPath } from "@/utils/CockpitPath";
import { COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK } from "@/utils/colors";
import { themed } from "@/utils/Theme";

/**
 * Shown for an IRES Office address that does not exist: a mistyped link, an old bookmark, a removed
 * page (ticket 2610063). It renders inside Scaffold, so the app bar and the menu stay in place,
 * where it used to be a bare "404" on an empty white page.
 *
 * A page that exists but is not open to the user never lands here: the route guard sends that to
 * the Cockpit with a message instead.
 */
@Component
export default class NotFoundComponent extends Vue {
  get tableHeaderColor() {
    return themed(COLOR_TABLE_HEADER, COLOR_TABLE_HEADER_DARK);
  }

  /** The admin portal client has its own cockpit, as everywhere else (`getCockpitPath`). */
  get cockpitPath() {
    return getCockpitPath(isOfficeAdminPortalClient());
  }
}
